import { FC } from 'react';

import CheckMark from '../../../assets/icons/checkMark.svg';
import Close from '../../../assets/icons/close.svg';
import Select from '../select/select';

export interface ISelectPopupOption {
	value: string;
	label: string;
}

interface ISelectPopupProps {
	handleClickAcceptBtn: () => void;
	handleClickCancelBtn: () => void;
	handleChangeValue: (selectedOption: ISelectPopupOption) => void;
	options: ISelectPopupOption[];
	value?: string;
	defaultValue?: string;
	className?: string;
	selectClassName?: string;
	modalRef: React.RefObject<HTMLDivElement> | null;
	selectStyle?: { [key: string]: string };
}

const SelectPopup: FC<ISelectPopupProps> = ({
	handleClickAcceptBtn,
	handleClickCancelBtn,
	handleChangeValue,
	options,
	value,
	defaultValue = '',
	className = 'edit__popup',
	selectClassName = 'check__select',
	modalRef,
	selectStyle = { width: '100%' },
}) => {
	const selectedValue = value || defaultValue;

	return (
		<div className={className} ref={modalRef}>
			<Select
				value={{
					value: selectedValue,
					label: selectedValue,
				}}
				options={options}
				propsChange={handleChangeValue}
				className={selectClassName}
				style={selectStyle}
			/>
			<div className='btns__block'>
				<button onClick={handleClickAcceptBtn} className='accept__name_btn'>
					<img className='check__mark_icon' src={CheckMark} alt='accept' />
				</button>
				<button onClick={handleClickCancelBtn} className='cancel__name_btn'>
					<img src={Close} alt='close' />
				</button>
			</div>
		</div>
	);
};

export default SelectPopup;
